// Equalize carousel card heights for perfect MG swatch alignment
document.addEventListener('DOMContentLoaded', function() {
  function equalizeCarouselHeights() {
    // Find all carousel grids
    const carouselGrids = document.querySelectorAll('ul.slider__grid.grid');

    carouselGrids.forEach(grid => {
      const cards = grid.querySelectorAll('.card--product');
      if (cards.length === 0) return;

      // Get all top sections
      const topSections = Array.from(cards).map(card => card.querySelector('.card__section-1'));
      if (topSections.length === 0 || !topSections[0]) return;

      // BATCH WRITE: Reset all heights first
      topSections.forEach(section => {
        if (section) section.style.height = 'auto';
      });

      // BATCH READ: Read all heights after single reflow
      let maxHeight = 0;
      topSections.forEach(section => {
        if (!section) return;
        const height = section.offsetHeight;
        if (height > maxHeight) maxHeight = height;
      });

      // BATCH WRITE: Apply the max height to all top sections
      if (maxHeight > 0) {
        topSections.forEach(section => {
          if (section) {
            section.style.height = maxHeight + 'px';
            section.style.minHeight = maxHeight + 'px';
          }
        });
      }
    });
  }

  // Run immediately
  equalizeCarouselHeights();

  // Run after images load
  window.addEventListener('load', equalizeCarouselHeights);

  // Run on resize
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(equalizeCarouselHeights, 250);
  });

  // Run when carousels are initialized (if they use custom events)
  document.addEventListener('carousel:initialized', equalizeCarouselHeights);
});
